import React from 'react'
import logoImage from '../../assets/logo-iprejun-horizontal.png'

const Logo: React.FC = () => {
  return (
    <img
      src={logoImage}
      alt="logo-iprejun"
      className="h-full py-[15px] max-[766px]:py-[5px]"
    />
  )
}

export default Logo
